import { CurrencyInput } from 'browser/components/atomic-elements/atoms/input/currency-input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const CurrencyField = LabelFieldFactory({ InputComponent: CurrencyInput })
export { CurrencyField }
